import React, { Suspense, useEffect } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import FreeAuthRoute from "./routes/FreeAuthRoute";
import PageNotFound from "./pages/PageNotFound";
import { routerData } from "./config/RoutesConfig";
import FrontLayout from "./layouts/front/FrontLayout";
import AdminLayout from "./layouts/auth/AdminLayout";
import UserRoute from "./routes/UserRoute";
import AdminRoute from "./routes/AdminRoute";
import BlankLayout from "./layouts/BlankLayout";
import AuthRoute from "./routes/AuthRoute";
import LoadingFallback from "./components/elements/LoadingFallback";
import AdminNotAllowRoute from "./routes/AdminNotAllowRoute";
import { useSelector } from "react-redux";
import DonorRoute from "./routes/DonorRoute";
import UserLayout from "./layouts/user/UserLayout"; 
import AuthLayout from "./layouts/AuthLayout";
import FrontRoute from "./routes/FrontRoute"; 

const CreateRoutes = () => {
  const { session } = useSelector((state) => state?.authProvider);

  return (
    <Suspense fallback={<LoadingFallback />}>
      <ScrollToTop>
        <Routes>
          {(
            routerData({
              user: session?.user,
            }) || []
          )
            ?.filter((item) => !item?.disabled || item?.disabled === undefined)
            ?.map((route, i) => {
              console.log(route.layout)
              let Layout = React.Fragment;

              if (route.layout === "front") {
                Layout = FrontLayout;
              } else if (route.layout === "user") {
                Layout = UserLayout;
              } else if (route.layout === "user") {
                Layout = AuthLayout;
              } else if (route.layout === "admin") {
                Layout = AdminLayout;
              } else if (!route.layout) {
                Layout = BlankLayout;
              }

              return (
                <Route
                  key={route?.key || i}
                  path={route.path}
                  element={
                    route?.routeType === "user" ? (
                      <UserRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </UserRoute>
                    ) : route?.routeType === "admin" ? (
                      <AdminRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </AdminRoute>
                    ) : route?.routeType === "auth" ? (
                      <AuthRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </AuthRoute>
                    ) : route?.routeType === "adminNotAllow" ? (
                      <AdminNotAllowRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </AdminNotAllowRoute>
                    ) : route?.routeType === "front" ? (
                      <FrontRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </FrontRoute>
                    ) : (
                      <FreeAuthRoute>
                        <Layout metaTitle={route?.title || ""} />
                      </FreeAuthRoute>
                    )
                  }
                >
                  <Route
                    path={route?.path}
                    exact
                    element={<route.component />}
                  />
                  {route?.subRoute?.map((sub, j) => (
                    <Route
                      key={j?.toString()}
                      path={sub?.path}
                      exact
                      element={<sub.component />}
                    />
                  ))}
                </Route>
              );
            })}
          {/* 404 Page */}
          <Route path="*" element={<Navigate to="/admin/signin" replace />} />
        </Routes>
      </ScrollToTop>
    </Suspense>
  );
};

export default CreateRoutes;
